/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import global from "./global";
import auth from "./auth";
import verification from "./verification";
import stall from "./stall";
import category from "./category";
import food from "./food";
import favourite from "./favourite";
import me from "./me";
import wallet from "./wallet";
import review from "./review";
import user from "./user";
import profile from "./profile";
import search from "./search";
import page from "./page";
import point from "./point";
import notification from "./notification";
import warning from "./warning";
import common from "./common";
import banner from "./banner";

export default history =>
  combineReducers({
    router: connectRouter(history),
    global,
    auth,
    verification,
    stall,
    category,
    food,
    favourite,
    me,
    wallet,
    review,
    user,
    profile,
    search,
    page,
    point,
    notification,
    warning,
    common,
    banner
  });



// WEBPACK FOOTER //
// ./src/reducers/index.js